<div class="modal-content templateUploader">
  <div class="modal-header">
    <button
      type="button"
      class="close"
      aria-hidden="true"
      (click)="closeModal()"
    >
      ×
    </button>
    <h3>Uploaded Images</h3>
  </div>
  <div class="modal-body row">
    <div class="col-md-6">Select image click on an image to select</div>

    <div class="col-md-12 flex-container__centered">
      <button
        class="btn-link border-none no-padding-left"
        aria-hidden="true"
        (click)="openPreview()"
        tooltip="Display image selected"
      >
        <span class="glyphicon glyphicon-eye-open" aria-hidden="true"></span>
      </button>
      <div class="item-grow"></div>
      <div class="flex-container__centered col">
        <div>
          <input
            type="checkbox"
            aria-label="..."
            (change)="onChangeAllUser($event.target.checked)"
            [ngModel]="hideAllOtherUsers"
          />
          Hide all other users' folders
        </div>
        <div>
          <input
            type="checkbox"
            aria-label="..."
            (change)="onChangeCurrentUser($event.target.checked)"
            [ngModel]="hideCurrentUser"
          />
          Hide current user's folders
        </div>
        <div>
          <input
            type="checkbox"
            aria-label="..."
            (change)="onChangeBackup($event.target.checked)"
            [ngModel]="hideBackupFolder"
          />
          Hide backup files (.old files)
        </div>
        <div>
          <input
            type="checkbox"
            aria-label="..."
            (change)="onChangeTemporary($event.target.checked)"
            [ngModel]="hideTemporaryFolder"
          />
          Hide temporary files (tmp folder)
        </div>
      </div>
    </div>

    <div class="col-md-12 border-top">
      <ng-container *ngIf="dirstructure$ | async as distructure; else loading">
        <p-tree
          [value]="distructure"
          selectionMode="single"
          [selection]="selectedNode"
          (onNodeExpand)="loadNode($event)"
          (onNodeSelect)="selectNode($event)"
          scrollHeight="500px"
        >
        </p-tree>
      </ng-container>
      <ng-template #loading>
        <img src="/img/loading.gif" alt="loading" />
      </ng-template>
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-primary" aria-hidden="true" (click)="success()">
      Use Image
    </button>
    <button class="btn btn-default" aria-hidden="true" (click)="closeModal()">
      Close
    </button>
  </div>
</div>
